import { Component } from "@angular/core";

@Component({
  templateUrl: "./performance-view.component.html",
})
export class PerformanceViewComponent {}
